export default __webpack_public_path__ + "static/media/4.c02164e8.svg";